module.exports = __webpack_public_path__ + "img/4.882dc404.png";